<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/setting/print/normal' }"
            >小票设置</el-breadcrumb-item
          >
          <el-breadcrumb-item>模板管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane
            v-for="(item, index) in pathList"
            :key="String(item.printTempType)"
            :label="item.name"
            :name="String(item.printTempType)"
          >
            <div class="content-container clearfix" v-if="index == 0">
              <div
                class="left"
                :class="takeOutTabPosition == 58 ? 'wid' : 'wid2'"
              >
                <el-radio-group v-model="takeOutTabPosition" size="small">
                  <el-radio-button label="58">58mm</el-radio-button>
                  <el-radio-button label="80">80mm</el-radio-button>
                </el-radio-group>
                <div class="temp-main">
                  <div class="temp-main_text">
                    <div class="text1 center" v-if="takeOutForm.showShopName">
                      {{ takeOutForm.shopName }}
                    </div>
                    <p class="split-line">
                      <span class="words">已在线支付</span>
                      <span class="line" style="float:left;"></span>
                      <span class="line" style="float: right;"></span>
                    </p>
                    <!-- 订单信息 -->
                    <div class="order">
                      <div class="text2">*外卖* #00534</div>
                      <div class="text3">
                        <div>单号：</div>
                        <div>E20180909154500025400007</div>
                      </div>
                      <div class="text3">
                        <div>下单时间：</div>
                        <div>2018-09-09 18:28:53</div>
                      </div>
                      <div class="text3" v-if="takeOutForm.showShopTel">
                        <div>电话：</div>
                        <div>{{ takeOutForm.shopTel }}</div>
                      </div>
                      <div class="text3" v-if="takeOutForm.showShopAddress">
                        <div>地址：</div>
                        <div>{{ takeOutForm.shopAddress }}</div>
                      </div>
                    </div>
                    <div style=" border-bottom: 1px solid #eee;">
                      <div class="text4">
                        <div class="text">菜名/规格</div>
                        <div class="text">数量</div>
                        <div class="text">金额</div>
                      </div>
                      <div
                        class="text5"
                        :class="{ big: takeOutForm.fontSizeForKitchen == 2 }"
                      >
                        <div style="flex:1;text-align:left;">
                          商品名称(规格)
                        </div>
                        <div style="flex:1;text-align:center;">x2</div>
                        <div style="flex:1;text-align:right;">10.00</div>
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid #eee;">
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>总数：</div>
                        <div>2</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>餐盒费:</div>
                        <div>1.00</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>配送费:</div>
                        <div>2.00</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>优惠：</div>
                        <div>- 2.00</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 18px;"
                      >
                        <div>总计：</div>
                        <div>11.00</div>
                      </div>
                    </div>
                    <div class="man">
                      <div
                        class
                        style="margin-bottom: 5px;display: flex;margin-top:5px;"
                      >
                        <div style>
                          <span style="margin-right:10px;">买家</span
                          >123*****901
                        </div>
                      </div>
                      <div
                        class
                        style="margin-bottom: 10px;display: flex;margin-top:5px;"
                      >
                        <div style>望江西路108号d幢100</div>
                      </div>
                      <div style="margin-bottom: 5px;display: flex;">
                        <div style="width: 38px;">备注：</div>
                        <div style="flex: 1 1 0%;">备注内容</div>
                      </div>
                    </div>
                    <div class="line" v-if="takeOutForm.showShopNotice">
                      <p style="text-align: left; margin-top: 5px;">
                        {{ takeOutForm.shopNotice }}
                      </p>
                    </div>
                    <div
                      class
                      style="margin:10px 0; text-align: center;"
                      v-if="takeOutForm.showInvoice"
                    >
                      <p
                        style="font-size: 14px; font-weight: bold; margin-top: 5px;"
                      >
                        开票二维码
                      </p>
                      <qrcode
                        :value="null"
                        :options="{ size: 160 }"
                        class="scan-code-img"
                      ></qrcode>
                      <p style="font-size: 14px;line-height: 14px;">扫码开票</p>
                    </div>
                    <div
                      class
                      style="margin:10px 0; text-align: center;"
                      v-if="takeOutForm.showAdUrl"
                    >
                      <qrcode
                        :value="takeOutForm.adUrl"
                        :options="{ size: 160 }"
                        class="scan-code-img"
                      ></qrcode>
                      <p style="font-size: 14px;line-height: 14px;">扫一扫</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <el-form ref="form" :model="takeOutForm" label-width="140px">
                  <el-form-item label="店铺名称">
                    <el-radio-group v-model="takeOutForm.showShopName">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="takeOutForm.showShopName"
                      v-model="takeOutForm.shopName"
                      placeholder="请输入店铺名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺电话">
                    <el-radio-group v-model="takeOutForm.showShopTel">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="takeOutForm.showShopTel"
                      v-model="takeOutForm.shopTel"
                      placeholder="请输入店铺电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺地址">
                    <el-radio-group v-model="takeOutForm.showShopAddress">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="takeOutForm.showShopAddress"
                      v-model="takeOutForm.shopAddress"
                      placeholder="请输入店铺地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺公告">
                    <el-radio-group v-model="takeOutForm.showShopNotice">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="takeOutForm.showShopNotice"
                      v-model="takeOutForm.shopNotice"
                      placeholder="请输入店铺地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="广告链接">
                    <el-radio-group v-model="takeOutForm.showAdUrl">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="takeOutForm.showAdUrl"
                      v-model="takeOutForm.adUrl"
                      placeholder="请输入广告链接"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开票码（开发中）">
                    <el-radio-group v-model="takeOutForm.showInvoice">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="厨房打印字号">
                    <el-radio-group v-model="takeOutForm.fontSizeForKitchen">
                      <el-radio :label="1">正常</el-radio>
                      <el-radio :label="2">大号</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </div>
              <div class="footer">
                <el-button @click="pageBack">返回</el-button>
                <el-button type="primary" @click="save(takeOutForm)"
                  >应用</el-button
                >
              </div>
            </div>
            <div class="content-container clearfix" v-if="index == 1">
              <div class="left" :class="tangTabPosition == 58 ? 'wid' : 'wid2'">
                <el-radio-group v-model="tangTabPosition" size="small">
                  <el-radio-button label="58">58mm</el-radio-button>
                  <el-radio-button label="80">80mm</el-radio-button>
                </el-radio-group>
                <div class="temp-main">
                  <div class="temp-main_text">
                    <div class="text1 center" v-if="tangForm.showShopName">
                      {{ tangForm.shopName }}
                    </div>
                    <p class="split-line">
                      <span class="words">未支付</span>
                      <span class="line" style="float:left;"></span>
                      <span class="line" style="float: right;"></span>
                    </p>
                    <!-- 订单信息 -->
                    <div class="order">
                      <div class="text2">*堂食* #00534</div>
                      <div class="text3">
                        <div>单号：</div>
                        <div>E20180909154500025400007</div>
                      </div>
                      <div class="text3">
                        <div>下单时间：</div>
                        <div>2018-09-09 18:28:53</div>
                      </div>
                      <div class="text3" v-if="tangForm.showShopTel">
                        <div>电话：</div>
                        <div>{{ tangForm.shopTel }}</div>
                      </div>
                      <div class="text3" v-if="tangForm.showShopAddress">
                        <div>地址：</div>
                        <div>{{ tangForm.shopAddress }}</div>
                      </div>
                    </div>
                    <div style=" border-bottom: 1px solid #eee;">
                      <div class="text4">
                        <div class="text">菜名/规格</div>
                        <div class="text">数量</div>
                        <div class="text">金额</div>
                      </div>
                      <div
                        class="text5"
                        :class="{ big: takeOutForm.fontSizeForKitchen == 2 }"
                      >
                        <div style="flex:1;text-align:left;">
                          商品名称(规格)
                        </div>
                        <div style="flex:1;text-align:center;">x2</div>
                        <div style="flex:1;text-align:right;">10.00</div>
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid #eee;">
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>总数：</div>
                        <div>2</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>餐盒费：</div>
                        <div>1.00</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px;"
                      >
                        <div>优惠：</div>
                        <div>- 2.00</div>
                      </div>
                      <div
                        class="text6"
                        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 18px;"
                      >
                        <div>总计:</div>
                        <div>9.00</div>
                      </div>
                    </div>
                    <div class="man">
                      <div
                        class
                        style="margin-bottom: 5px;display: flex;margin-top:5px;"
                      >
                        <div style>
                          <span style="margin-right:10px;">5号桌</span>5人用餐
                        </div>
                      </div>
                      <div style="margin-bottom: 5px;display: flex;">
                        <div style="width: 38px;">备注：</div>
                        <div style="flex: 1 1 0%;">备注内容</div>
                      </div>
                    </div>
                    <div class="line" v-if="tangForm.showShopNotice">
                      <p style="text-align: left; margin-top: 5px;">
                        {{ tangForm.shopNotice }}
                      </p>
                    </div>
                    <div
                      class
                      style="margin:10px 0; text-align: center;"
                      v-if="tangForm.showInvoice"
                    >
                      <p
                        style="font-size: 14px; font-weight: bold; margin-top: 5px;"
                      >
                        开票二维码
                      </p>
                      <qrcode
                        :value="null"
                        :options="{ size: 160 }"
                        class="scan-code-img"
                      ></qrcode>
                      <p style="font-size: 14px;line-height: 14px;">扫码开票</p>
                    </div>
                    <div
                      class
                      style="margin:10px 0; text-align: center;"
                      v-if="tangForm.showAdUrl"
                    >
                      <qrcode
                        :value="tangForm.adUrl"
                        :options="{ size: 160 }"
                        class="scan-code-img"
                      ></qrcode>
                      <p style="font-size: 14px;line-height: 14px;">扫一扫</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <el-form ref="form" :model="tangForm" label-width="140px">
                  <el-form-item label="店铺名称">
                    <el-radio-group v-model="tangForm.showShopName">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="tangForm.showShopName"
                      v-model="tangForm.shopName"
                      placeholder="请输入店铺名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺电话">
                    <el-radio-group v-model="tangForm.showShopTel">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="tangForm.showShopTel"
                      v-model="tangForm.shopTel"
                      placeholder="请输入店铺电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺地址">
                    <el-radio-group v-model="tangForm.showShopAddress">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="tangForm.showShopAddress"
                      v-model="tangForm.shopAddress"
                      placeholder="请输入店铺地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="店铺公告">
                    <el-radio-group v-model="tangForm.showShopNotice">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="tangForm.showShopNotice"
                      v-model="tangForm.shopNotice"
                      placeholder="请输入店铺地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="广告链接">
                    <el-radio-group v-model="tangForm.showAdUrl">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                    <el-input
                      type="textarea"
                      v-if="tangForm.showAdUrl"
                      v-model="tangForm.adUrl"
                      placeholder="请输入广告链接"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开票码（开发中）">
                    <el-radio-group v-model="tangForm.showInvoice">
                      <el-radio :label="1">显示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="厨房打印字号">
                    <el-radio-group v-model="tangForm.fontSizeForKitchen">
                      <el-radio :label="1">正常</el-radio>
                      <el-radio :label="2">大号</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </div>
              <div class="footer">
                <el-button @click="pageBack">返回</el-button>
                <el-button type="primary" @click="save(tangForm)"
                  >应用</el-button
                >
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrintTempConfig, setPrintTempConfig } from "@/api/index.js";
import { mapState } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
export default {
  data() {
    return {
      activeName: "2",
      pathList: [
        {
          name: "外卖小票",
          printTempType: "2",
        },
        {
          name: "堂食小票",
          printTempType: "1",
        },
      ],
      takeOutForm: {
        printTempType: 2,
        shopAddress: "888888", //商店地址
        shopId: 1,
        shopName: "11212", //商店名称
        shopNotice: "这是店铺公告", //商店公告
        shopTel: "6047195215", //商店电话
        showOrderNum: 1, //是否显示订单号
        showShopAddress: 0, //是否显示地址
        showShopName: 1, //是否显示店名
        showShopNotice: 0, //是否显示公告
        showShopTel: 0, //是否显示电话
        showAdUrl: 1, //是否显示广告链接
        adUrl: "", //广告链接
        showInvoice: 0, //是否显示开票码
        textSize: 58, //打印宽度
        fontSizeForKitchen: 1, //厨房打印字号
      },
      tangForm: {
        printTempType: 1,
        shopAddress: "888888", //商店地址
        shopId: 1,
        shopName: "11212", //商店名称
        shopNotice: "这是店铺公告", //商店公告
        shopTel: "6047195215", //商店电话
        showOrderNum: 1, //是否显示订单号
        showShopAddress: 0, //是否显示地址
        showShopName: 1, //是否显示店名
        showShopNotice: 0, //是否显示公告
        showShopTel: 0, //是否显示电话
        showAdUrl: 1, //是否显示广告链接
        adUrl: "", //广告链接
        showInvoice: 0, //是否显示开票码
        textSize: 58, //打印宽度
        fontSizeForKitchen: 1, //厨房打印字号
      },
      takeOutTabPosition: "58",
      tangTabPosition: "58",
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  watch: {
    activeName() {
      this.getPrintTempConfig();
    },
  },
  mounted() {
    this.getPrintTempConfig();
  },
  methods: {
    getPrintTempConfig() {
      getPrintTempConfig({
        printTempType: Number(this.activeName),
        printType: 1,
      }).then((res) => {
        if (res.code == 1) {
          if (this.activeName == 2) {
            this.takeOutForm = res.data;
          } else {
            this.tangForm = res.data;
          }
        }
      });
    },
    pageBack() {
      this.$router.go(-1);
    },
    save(form) {
      form.shopId = this.shop.shopId;
      form.showInvoice = 0;
      setPrintTempConfig(form).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "保存成功",
            type: "success",
            duration: 2000,
          });
          setTimeout(() => {
            this.pageBack();
          }, 1000);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tab-content {
  padding: 20px;
  min-width: 1000px;
  .el-tabs {
    width: 100%;
  }
  .footer {
    text-align: center;
  }
  .content-container {
    padding-top: 10px;
    text-align: center;
    .left {
      padding-right: 65px;
      vertical-align: top;
      display: inline-block;
    }
    .wid {
      width: 340px;
    }
    .wid2 {
      width: 380px;
    }
    .right {
      display: inline-block;
      padding-top: 50px;
      text-align: left;
    }
    .temp-main {
      padding-top: 25px;
      color: #000;
      text-align: left;
      padding-bottom: 50px;
      margin: 0 auto;
      box-sizing: border-box;
      word-break: break-word;
      width: 100%;
      line-height: 1.5;
      .temp-main_text {
        min-height: 480px;
        min-width: 340px;
        border: 1px solid #e6e6e6;
        padding: 40px 30px;
        position: relative;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
        box-sizing: border-box;
        &:before {
          content: "";
          position: absolute;
          height: 10px;
          left: 0;
          right: 0;
          background: linear-gradient(45deg, #fff 50%, transparent 0),
            linear-gradient(135deg, transparent 50%, #fff 0);
          background-size: 20px 20px;
          top: -10px;
        }
        .split-line {
          margin: 14px 0;
          .words {
            width: 100%;
            display: inline-block;
            text-align: center;
            font-size: 14px;
          }
          .line {
            width: 25%;
            border-bottom: 1px solid #ecddeb;
            margin-top: -9px;
            display: inline-block;
          }
        }
        .text4 {
          font-size: 12px;
          margin-bottom: 10px;
          width: 100%;
          display: flex;
          .text {
            flex: 1;
            text-align: center;
          }
        }
        .text1 {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 10px;
          word-break: break-all;
        }
        .text2 {
          margin-bottom: 5px;
          font-size: 15px;
          font-weight: bold;
        }
        .order {
          margin-bottom: 5px;
          font-size: 15px;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
        .text {
          &:first-child {
            text-align: left;
          }
          &:last-child {
            text-align: right;
          }
        }

        .center {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .column {
          display: flex;
          flex-direction: column;
        }
        .text3 {
          font-size: 12px;
          margin-bottom: 5px;
          display: flex;
          font-weight: 400;
          & > div:first-child {
            min-width: 36px;
          }
        }
        .text5 {
          font-size: 12px;
          margin-bottom: 10px;
          width: 100%;
          display: flex;
          flex-direction: row;
          &.big {
            font-size: 30px;
          }
        }
        .text6 {
          font-size: 12px;
        }
        .text7 {
          text-align: center;
        }
        .man {
          font-size: 12px;
          display: flex;
          flex-direction: column;
        }
        .line {
          height: 0;
          border-bottom: 1px dotted #ccc;
          margin-bottom: 10px;
        }
        .img {
          width: 100px;
          height: 100px;
          margin-bottom: 10px;
        }
        .scan-code-img {
          width: 160px;
          height: 160px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
